import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors, font } from '../theme/tokens';

type Props = {
  /** Render for a dark background. */
  onDark?: boolean;
  /** Suppress the wordmark and show the glyph only. */
  glyphOnly?: boolean;
};

/**
 * Brand mark: the Bode logo, with a small Open Capacity caption so it is clear
 * whose prototype lab this is.
 *
 * The SVG in public/bode-logo.svg was taken from bode-global.com. If the copy
 * attached to J. Funk's mail of 18 Sep differs, replace that file — nothing
 * here needs changing.
 */
const Mark: React.FC<Props> = ({ onDark = false, glyphOnly = false }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5 }}>
    <Box
      component="img"
      src={`${process.env.PUBLIC_URL}/bode-logo.svg`}
      alt="BODE"
      sx={{
        height: 20,
        // Styleguide: the protection zone equals the height of the door symbol
        // and must be kept proportionally. At 20px that is 20px of clear space.
        mr: '4px',
        width: 'auto',
        display: 'block',
        flexShrink: 0,
        // The logo ships in brand blue; invert it to white on dark surfaces.
        filter: onDark ? 'brightness(0) invert(1)' : 'none',
      }}
    />
    {!glyphOnly && (
      <>
        <Box sx={{
          width: '1px',
          height: 14,
          backgroundColor: onDark ? colors.onDarkBorder : colors.borderStrong,
          flexShrink: 0,
        }} />
        <Typography sx={{
          fontFamily: font.mono,
          fontSize: '10px',
          fontWeight: 500,
          letterSpacing: '0.16em',
          color: onDark ? colors.onDarkMuted : colors.inkFaint,
          textTransform: 'uppercase',
          whiteSpace: 'nowrap',
        }}>
          OC Lab
        </Typography>
      </>
    )}
  </Box>
);

export default Mark;
